<template>
  <div class="text-brand-brown text-sm font-semibold">
    <div v-if="isViewOnly">
      <i class="el-icon-lock text-base"></i>
      View Only
    </div>
    <div v-else-if="status === SAVE_STATE.SAVED">
      <i class="el-icon-circle-check text-base"></i>
      Saved
    </div>
    <div v-else-if="status === SAVE_STATE.SAVING">
      <i class="el-icon-loading text-base"></i>
      Saving…
    </div>
    <div v-else-if="status === SAVE_STATE.UNSAVED">
      <i class="el-icon-edit text-base"></i>
      Unsaved
    </div>
    <div v-else-if="status === SAVE_STATE.ERROR_SAVING">
      <i class="el-icon-warning-outline text-base mr-1"></i>
      Error Saving
    </div>
  </div>
</template>

<script>
import { SAVE_STATE } from '@/store/shared';
import { mapGetters } from 'vuex';

export default {
  name: 'SaveStateTag',
  props: { status: String },
  data() {
    return {
      SAVE_STATE,
    };
  },
  computed: {
    ...mapGetters(['isViewOnly']),
  },
};
</script>
